import React from 'react';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Situations } from './components/Situations';
import { Comparison } from './components/Comparison';
import { Gallery } from './components/Gallery';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { KitBonuses } from './components/KitBonuses';
import { Pricing } from './components/Pricing';
import { KitPricing } from './components/KitPricing';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
import { useMetaPixel } from './hooks/useMetaPixel';
import { kitFaqs, kitFinalCta, kitHero, kitStats } from './data/kitOffer';
interface AppProps {
  /** "attuale" = live offer (100 mappe + 6 bonus). "kitProfessionali" = draft preview with the 6 new kits, keep off until the PDFs are ready. */
  offerVersion?: 'attuale' | 'kitProfessionali';
  showTestimonials?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  offerVersion = 'kitProfessionali',
  showTestimonials = false,
  showPurchaseNotifications = false
}: AppProps) {
  useMetaPixel();
  const isKit = offerVersion === 'kitProfessionali';
  return <div className="w-full bg-white text-slate-900 antialiased" data-id="element-0" data-mp="2zmemk4sx3e5x">
      <main data-id="element-1" data-mp="33m5ck6amdq9e">
        {isKit ? <Hero subheadline={kitHero.subheadline} description={kitHero.description} data-id="element-2" data-mp="33n6zb810016y" /> : <Hero data-id="element-3" data-mp="38k6ugnwb7jja" />}
        {isKit ? <ProofBar stats={kitStats} data-id="element-4" data-mp="38o4ct7b2c724" /> : <ProofBar data-id="element-5" data-mp="3dl4n5uey3vz1" />}
        <Situations data-id="element-6" data-mp="3dlnukh6yz1yt" />
        <Comparison data-id="element-7" data-mp="3dm5ze27p6oic" />
        <Gallery data-id="element-8" data-mp="3dii716dzo857" />
        <WhatYouGet data-id="element-9" data-mp="nvssd0714ftu" />
        {isKit ? <KitBonuses data-id="element-10" data-mp="nur762waucye" /> : <Bonuses data-id="element-11" data-mp="nv1284w7baay" />}
        {isKit ? <KitPricing data-id="element-12" data-mp="nxx0jubyo0zx" /> : <Pricing data-id="element-13" data-mp="sudmqizlo5ad" />}
        <Guarantee data-id="element-14" data-mp="studdqo0mp7y" />
        {showTestimonials && <Testimonials data-id="element-15" data-mp="ssstcwp0use3" />}
        {isKit ? <Faq faqs={kitFaqs} data-id="element-16" data-mp="3686tkdjumw2" /> : <Faq data-id="element-17" data-mp="35ovwnmbgyrj" />}
        {isKit ? <FinalCta copy={kitFinalCta} data-id="element-18" data-mp="34x31kk3tf4y" /> : <FinalCta data-id="element-19" data-mp="38b2ol1dva8p" />}
      </main>
      <Footer data-id="element-20" data-mp="3udkoe0ich2ci" />
      {showPurchaseNotifications && <PurchaseToast data-id="element-21" data-mp="3uevrdy3yu62k" />}
    </div>;
}